<template>
  <div class="flex justify-between items-center header">
    <div class="left">
      <div class="logo" style="cursor: pointer">
        <img src="@/assets/imgs/Inspay.png" @click="toHome" alt="" />
      </div>
      <!-- <div class="logo-text" style="cursor: pointer" @click="toHome">
        INSPAY
      </div> -->
      <div class="logo-text-2" style="cursor: pointer" @click="toHome">
        &nbsp; Home
      </div>
      <!-- <div class="logo-text-2" style="cursor: pointer" @click="toOpenCard">
        &nbsp; Activation Guide
      </div> -->
    </div>
    <!-- 统一显示横向布局 -->
    <div class="flex justify-start items-center right">
      <el-button type="info" class="customBtn loginBtn" @click="toLogin">{{
        $t("Login")
      }}</el-button>
      <!-- <el-dropdown
        trigger="click"
        @command="handleCommand"
        placement="bottom-end"
        popper-class="mobile-dropdown"
      >
        <div class="langBox">
          <img src="@/assets/imgs/Vector.png" alt="" class="language" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(lang, index) in langs"
            :key="index"
            :command="lang"
            :class="curLanguage == lang.value ? 'languageActive' : ''"
            >{{ lang.text }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "header-page",
  data() {
    return {
      langs: [
        { text: "English", value: "en" },
        // { text: "中文", value: "zh" },
      ],
      curLanguage: localStorage.getItem("accept_language"),
      currentLan: "",
    };
  },
  methods: {
    toHome() {
      window.location.href = "/";
    },
    handleCommand(command) {
      localStorage.setItem("accept_language", command.value);
      this.$i18n.locale = command.value;
      this.currentLan = this.langs.find(
        (item) => item.value === command.value
      )?.text;
      window.location.reload();
    },
    toLogin() {
      window.location.href = "https://card.inspay.cc/login";
    },
    toOpenCard() {
      this.$router.push("/opencard");
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  max-width: 1440px;
  height: 72px;
  padding: 18px 60px;
  color: #fff;
  background-color: #000000;

  @media (max-width: 768px) {
    padding: 18px 20px;

    .left {
      .logo {
        width: 60px !important;
        // height: 30px !important;
      }
      .logo-text {
        font-size: 16px !important;
      }
      .logo-text-2 {
        font-size: 12px !important;
      }
    }

    .right {
      .customBtn {
        font-size: 14px;
        padding: 8px 15px;
      }

      .language {
        width: 24px !important;
        height: 24px !important;
        margin-left: 15px;
      }
    }
  }

  .left {
    align-items: center;
    display: flex;
    align-items: center;
    font-family: "MiSans-Bold";
    font-size: 26px;
    line-height: 35.67px;
    text-align: left;

    .logo {
      width: 80px;
      // height: 40px;
    }
    .logo-text {
      font-size: 20px;
    }
    .logo-text-2 {
      margin-left: 60px;
      font-size: 14px;
    }
  }

  .right {
    .customBtn {
      color: #fff;
      border: none;
      background: transparent !important;

      &:hover {
        background: #003da6 !important;
      }

      &:active,
      &:focus {
        background: #003da6 !important;
        border: none !important;
      }
    }

    .loginBtn {
      color: #fff;
    }

    .language {
      margin-left: 20px;
      cursor: pointer;
      width: 20px;
      height: 20px;
    }

    .active {
      background-color: #1949a9;
      -webkit-background-clip: text;
      -webkit-text-fill-color: #1949a9;
      font-family: "MiSans-Demibold";
      font-size: 14px;
      font-weight: 600;
      line-height: 18.56px;
      text-align: left;
    }
  }
}

/* 移除默认的下拉菜单样式 */
:deep(.el-dropdown-menu) {
  display: none !important;
}

/* 移动端下拉菜单样式 */
:deep(.mobile-dropdown.el-popper[x-placement^="bottom"]) {
  @media (max-width: 768px) {
    position: fixed !important;
    top: 80px !important;
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: none !important;
    transform: none !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    border-radius: 0 !important;
    background: rgba(0, 0, 0, 0.95) !important;
    display: block !important;

    .el-dropdown-menu {
      display: block !important;
      border: none !important;
      background: transparent !important;
      padding: 0 !important;
    }

    .el-dropdown-menu__item {
      font-size: 80px !important;
      padding: 60px !important;
      line-height: 1.4 !important;
      text-align: center !important;
      border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;
      color: #ffffff !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;

      &:hover {
        background: rgba(255, 255, 255, 0.15) !important;
      }

      &.languageActive {
        font-size: 80px !important;
        background: rgba(255, 255, 255, 0.9) !important;
        color: #003da6 !important;
        font-weight: bold !important;
      }
    }
  }
}
</style>
